import React from 'react';
import { Formik } from 'formik';

import { ARCADE_STRUCTURES } from 'constants/common';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';

import { MainLayout } from 'components/Layout';
import { BreadcrumbsToolbar } from 'components/Toolbar';
import { AutoSave } from 'components/AutoSave';
import { ToolbarActions } from 'components/ToolbarActions';
import { ReadOnlySection } from 'components/ReadOnlySection';

import { MainSettings } from 'pages/CoursePage/components/MainSettings';
import { LessonsSettings } from 'pages/CoursePage/components/LessonsSettings';
import { ModulesSettings } from 'pages/CoursePage/components/ModulesSettings';
import { StructureSelect } from 'pages/CoursePage/components/StructureSelect';
import { CourseResultPreview } from 'pages/CoursePage/components/CourseResultPreview';

import styles from 'pages/CoursePage/CoursePage.module.scss';

import {
  convertDataToForm,
  getContextItems,
  getReadonlyTrainingText,
} from './TrainingPage.helpers';

import { moreContextItems } from './TrainingPage.config';

const TrainingPage = ({
  loading,
  isRootAdmin,
  saveLoading,
  autoSaveLoading,
  readOnly,
  training,
  lastActionAt,
  onAutoSaveSubmit,
  onSaveClick,
  onPreviewClick,
  onStatusContextItemClick,
  onMoreContextItemClick,
}: {
  loading: any;
  isRootAdmin: any;
  saveLoading: any;
  autoSaveLoading: any;
  readOnly: any;
  training: any;
  lastActionAt: any;
  onAutoSaveSubmit: any;
  onSaveClick: any;
  onPreviewClick: any;
  onStatusContextItemClick: any;
  onMoreContextItemClick: any;
}) => (
  <Formik
    enableReinitialize
    validateOnMount
    initialValues={convertDataToForm(training)}
    onSubmit={onAutoSaveSubmit}
  >
    {({ values, setFieldValue }: { values: any; setFieldValue: any }) =>
      loading ? (
        <Loading />
      ) : (
        <MainLayout
          toolbarComponent={
            <BreadcrumbsToolbar
              breadcrumbsData={{
                courseTitle:
                  values.title || getTranslation('common.text.untitled'),
              }}
              endAdornment={
                <ToolbarActions
                  saveLoading={saveLoading}
                  isRootAdmin={isRootAdmin}
                  autoSaveLoading={autoSaveLoading}
                  contextItems={getContextItems(training.status)}
                  moreContextItems={moreContextItems}
                  updatedAt={lastActionAt}
                  status={training.status}
                  onSaveClick={() => onSaveClick(values)}
                  onPreviewClick={onPreviewClick}
                  onStatusContextItemClick={(item: any) =>
                    onStatusContextItemClick(item, { values, setFieldValue })
                  }
                  onMoreContextItemClick={onMoreContextItemClick}
                />
              }
            />
          }
        >
          <div className={styles.page}>
            <AutoSave debounceMs={1000} />
            {readOnly && (
              <ReadOnlySection
                text={getReadonlyTrainingText(training.status)}
              />
            )}
            <MainSettings type={training.type} />
            <CourseResultPreview type={training.type} />
            {!(values as Record<string, unknown>).structure && !readOnly && (
              <StructureSelect />
            )}
            {(values as Record<string, unknown>).structure ===
              ARCADE_STRUCTURES.MODULES && <ModulesSettings />}
            {(values as Record<string, unknown>).structure ===
              ARCADE_STRUCTURES.LESSONS && <LessonsSettings />}
          </div>
        </MainLayout>
      )
    }
  </Formik>
);

export default React.memo(TrainingPage) as any;
